import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit {
    location: any;
    routerSubscription: any;
    feedbackForm: FormGroup;
    submitted: boolean;
    selectOptions: any = [];

    constructor(private fb: FormBuilder, private router: Router) {
    }

    ngOnInit() {
        this.recallJsFuntions();
        this.feedbackForm = this.fb.group({
            full_name: ["", [Validators.required, Validators.pattern("^[a-zA-Z ]+$")]],
            company_name: ["", [Validators.required, Validators.pattern("^[a-zA-Z ]+$")]],
            email: ["", [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]],
            telephone: ["", [Validators.minLength(10), Validators.maxLength(10)]],
            fax: ["", [Validators.minLength(10), Validators.maxLength(15)]],
            mobile: ["", [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
            address: ["", Validators.required],
            website: [""],
            POConfirmation: [""],
            followUp: [""],
            despatch: [""],
            erection: [""],
            commissioning: [""],
            operatorFriendly: [""],
            safetyLevel: [""],
            features: [""],
            productionPerformance: [""],
            service: [""],
            feedback: ["", Validators.required],
        });
    }

    openFeedbackMod() {
        this.selectOptions = [
            {
                id : 1,
                option: 'Poor'
            },
            {
                id : 2,
                option: 'Satisfactory'
            },
            {
                id : 3,
                option: 'Good'
            },
            {
                id : 4,
                option: 'Excellent'
            },
        ]
    }

    numberOnly(event: any): boolean {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
            return false;
        }
        return true;
    }

    get con(): { [key: string]: AbstractControl } {
        return this.feedbackForm.controls;
    }

    onSubmit(): void {
        this.submitted = true;
        if (this.feedbackForm.invalid) {
            return;
        }
        const data = this.feedbackForm?.value;

        // this.spinner.show();

        // // Make the API call with the constructed data object
        // this.apiCall.contactUsForm(data).subscribe({
        //   next: (response) => {
        //     this.spinner.hide();
        //     if (response.success) {
        //       this.common.showMessage("success", response.message);
        //       this.feedbackForm.reset();
        //       this.submitted = false;
        //     } else {
        //       this.common.showMessage("error", response.message);
        //     }
        //   },
        //   error: (error: any) => {
        //     this.spinner.hide();
        //     this.common.showMessage("error", error?.message);
        //   },
        // });
    }

    recallJsFuntions() {
        this.router.events
            .subscribe((event) => {
                if (event instanceof NavigationStart) {
                    $('.preloader-area').fadeIn('slow');
                }
            });
        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
            .subscribe(event => {
                $.getScript('../assets/js/app.js');
                $('.preloader-area').fadeOut('slow');
                this.location = this.router.url;
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                window.scrollTo(0, 0);
            });
    }
}